import React, { useState, useEffect } from 'react';

const PWAStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  // Check if app is already installed
  useEffect(() => {
    const checkInstalled = () => {
      if (window.matchMedia('(display-mode: standalone)').matches || 
          window.navigator.standalone === true) {
        setIsInstalled(true);
      }
    };
    checkInstalled();
  }, []);

  // Handle online/offline status
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Handle PWA install prompt
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      if (!isInstalled) {
        setShowInstallPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [isInstalled]);

  const handleInstallApp = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response to the install prompt: ${outcome}`);
      setDeferredPrompt(null);
      setShowInstallPrompt(false);
    }
  };

  const dismissInstallPrompt = () => {
    setShowInstallPrompt(false);
    // Store dismissal in localStorage to avoid showing again for this session
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  // Don't show install prompt if user dismissed it in this session
  useEffect(() => {
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed === 'true') {
      setShowInstallPrompt(false);
    }
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          .pwa-install-prompt {
            animation: slideUp 0.3s ease-out;
          }
          
          .pwa-status .alert {
            margin-bottom: 10px;
            border-radius: 10px;
            border: none;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }
          
          .pwa-status .alert i {
            font-size: 16px;
          }
        `}
      </style>
      
      {/* PWA Install Prompt */}
      {showInstallPrompt && !isInstalled && (
        <div className="pwa-install-prompt" style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          right: '20px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '20px',
          borderRadius: '15px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          zIndex: 1000,
          animation: 'slideUp 0.3s ease-out'
        }}>
          <div className="install-content" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
            <div className="install-icon" style={{ 
              fontSize: '40px', 
              marginRight: '15px',
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              width: '60px',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <i className="simple-icon-plus"></i>
            </div>
            <div className="install-text">
              <h6 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>Install Exo Tiles</h6>
              <p style={{ margin: '5px 0 0 0', opacity: 0.9, fontSize: '14px' }}>Add to home screen for quick access</p>
            </div>
          </div>
          <div className="install-actions" style={{ display: 'flex', gap: '10px' }}>
            <button 
              className="btn btn-light" 
              onClick={handleInstallApp}
              style={{
                flex: 1,
                padding: '10px 20px',
                borderRadius: '25px',
                border: 'none',
                fontWeight: '500',
                background: 'rgba(255,255,255,0.9)',
                color: '#333'
              }}
            >
              Install App
            </button>
            <button 
              className="btn btn-outline-light" 
              onClick={dismissInstallPrompt}
              style={{
                flex: 1,
                padding: '10px 20px',
                borderRadius: '25px',
                border: '2px solid rgba(255,255,255,0.5)',
                background: 'transparent',
                color: 'white',
                fontWeight: '500'
              }}
            >
              Later
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PWAStatus;
